import { getProactiveDraftsStore } from '../store/store';

export function getProactiveDraftsBarVisibilityStatus(itemId: string | undefined): boolean {
    if (itemId) {
        // Get the proactive drafts bar expanded/collapsed state for the given key
        const proactiveDrafts = getProactiveDraftsStore().proactiveDraftsListMap.get(itemId);
        if (proactiveDrafts) {
            return proactiveDrafts.proactiveDraftsBarVisible;
        }
    }
    return true;
}
